import type { GetOnePriceOverrideRevertResponse, PriceOverrideRevert } from "@classes-service-types/index";
import { type UseMutationOptions, useMutation } from "@tanstack/vue-query";
import type { AxiosResponse } from "axios";
import { learningServiceRequest } from "@/services/utils";

type UsePriceOverridesRevertArgs = {
  payload: PriceOverrideRevert;
  name?: string;
};

export const usePriceOverridesRevert = (
  useMutationOptions?: UseMutationOptions<GetOnePriceOverrideRevertResponse, Error, UsePriceOverridesRevertArgs>,
) => {
  return useMutation<GetOnePriceOverrideRevertResponse, Error, UsePriceOverridesRevertArgs>({
    mutationFn: async (priceOverrideRevertArgs) => {
      const response: AxiosResponse<GetOnePriceOverrideRevertResponse> = await learningServiceRequest({
        method: "put",
        url: "/price_overrides/revert/",
        payload: priceOverrideRevertArgs.payload,
      });
      return response.data;
    },
    ...useMutationOptions,
  });
};
